import { useEffect, useState } from 'react';

/**
 * Object URL for an in-memory blob. Created when the blob is set and revoked
 * when it changes or the caller unmounts. Callers store the blob, not this URL.
 */
export function useObjectUrl(blob: Blob | null | undefined): string | null {
  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!blob) {
      setObjectUrl(null);
      return;
    }
    const url = URL.createObjectURL(blob);
    setObjectUrl(url);
    return () => {
      URL.revokeObjectURL(url);
    };
  }, [blob]);

  return objectUrl;
}
